// Selectors used by multiple seat map components but not by other areas of the application

import { createSelector } from '@ngrx/store';

import { seatBundleSelectionsByFlightAndPassengerSelector } from '../../../../store/selectors/bundle.selector';
import { seatMapNonBundledSeatSelectionsByFlightSelector } from '../../../../store/selectors/seat-map.selector';

/**
 * Combines non bundled seats and bundle seats to a map of passengerId to the seat number they have selected.
 */
export const selectedSeatNumberByFlightAndPassengerSelector = createSelector(
  seatMapNonBundledSeatSelectionsByFlightSelector,
  seatBundleSelectionsByFlightAndPassengerSelector,
  (nonBundledSeats, bundleServices) => {
    const flightIds = Array.from(
      new Set([...Object.keys(nonBundledSeats || {}), ...Object.keys(bundleServices || {})])
    );
    const paxIds = Array.from(
      new Set(
        flightIds.flatMap((fid) => [
          ...Object.keys(nonBundledSeats?.[fid] || {}),
          ...Object.keys(bundleServices?.[fid] || {}),
        ])
      )
    );

    return flightIds.reduce(
      (flightAcc, flightId) => ({
        ...flightAcc,
        [flightId]: paxIds.reduce((paxAcc, paxId) => {
          const paxRegularSeatNumber: string | undefined = nonBundledSeats[flightId]?.[paxId]?.seatNumber;
          const paxBundleSeatNumber: string | undefined = bundleServices[flightId]?.[paxId]?.find(
            (s) => s.seatNumber
          )?.seatNumber;

          return {
            ...paxAcc,
            [paxId]: paxBundleSeatNumber ?? paxRegularSeatNumber,
          };
        }, {}),
      }),
      {}
    );
  }
);
